import React, { Component } from 'react';

import { Parallax } from 'react-scroll-parallax';

import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import plusCircle from '@fortawesome/fontawesome-free-solid/faPlusCircle'

import '../css/Brands.css'


class BrandSection extends Component {
  constructor(props) {
    super(props)

    this.state = { show: false, classNames: ['brands-list'] };
    this.openContainer = this.openContainer.bind(this)
   
  }

  openContainer() {
    if (this.state.show) {
      this.setState({ classNames: ['brands-list'], show: false })
    } else {
      this.setState({ classNames: ['brands-list', 'show'], show: true })
    } 
  }

  render() {
    let { classNames } = this.state
    return (

      <div className="brand-section">
        <div className="brand-section-header" style={{backgroundImage: `linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url(${this.props.background})`}} onClick={() => { this.openContainer() }}>
        <Parallax
          offsetYMin={-100}
          offsetYMax={100}
          className="brand-section-title"
        >
          <h2>{this.props.title}</h2>
          <FontAwesomeIcon icon={plusCircle} size="2x" className="plus-circle"/>
        </Parallax>
        </div>
      <div className={classNames.join(' ')}>
        {this.props.brands.map((brand, index) => {
          return <p key={index} >{ brand }</p>
        })}
      </div>
      </div>
    );
  }
}

export default BrandSection;



// WEBPACK FOOTER //
// ./src/components/BrandSection.js